import useActions from 'hooks/useActions';
import useInputState from 'hooks/useInputState';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { VISIBILITY_OPTIONS } from 'constants/COMMUNITY_STATUS';


const { connect } = require('react-redux');

function mapStateToProps(state) {
    return {
        tagGroupOptions: state.CSTags.tagGroupOptions,
        selectedTag: state.CSTags.selectedTag,
        config: state.admins.config,
        user: state.user.user,
    };
}

const CSNewTag = connect(mapStateToProps)(function (props) {
    const { tagGroupOptions, selectedTag, config, user } = props;

    const allRegions = config?.regions;
    const userRegions = user?.permissions?.regions;
    const allNamedRegions = allRegions?.filter(({value}) => value !== 'all').map(({value}) => value);
    const userNamedRegions = userRegions?.filter((el) => el !== 'all');
    const regionsToShow = (userRegions?.includes('all')) ? allNamedRegions : userNamedRegions;

    const navigate = useNavigate();
    const { id } = useParams();
    const { CS_POST_TAG_REQUEST } = useActions();

    const [newTag, handleFieldChange] = useInputState({
        name: '',
        tag_group_id: id,
        visibility: VISIBILITY_OPTIONS[0].value,
        region_ident: '',
    });

    useEffect(() => {
        if (regionsToShow && regionsToShow.length > 0) {
            handleFieldChange({
                target: { name: 'region_ident', value: regionsToShow[0] },
            });
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (selectedTag) {
            navigate(`/community/tags`);
        }
        // eslint-disable-next-line
    }, [selectedTag]);

    const onSubmit = (event) => {
        event.preventDefault();
        CS_POST_TAG_REQUEST({
            name: newTag.name,
            tag_group_id: newTag.tag_group_id,
            visibility: newTag.visibility,
            region_ident: newTag.region_ident,
        });
    };

    return (
        <section>
            <div className="flex mb-4 items-center h-16">
                <div className="flex flex-1 items-center">
                    <div
                        className="font-bold cursor-pointer  text-lg"
                        onClick={() => {
                            navigate('/community/tags');
                        }}
                    >
                        Tags
                    </div>
                    <div className="ml-8 font-medium text-blue-600">
                        New Tag
                    </div>
                </div>
            </div>
            <form onSubmit={onSubmit}>
                <table className='edit-table'>
                    <tbody>
                        <tr>
                            <td className="font-bold label">Name</td>
                            <td>
                                <input
                                    name="name"
                                    value={newTag.name}
                                    onChange={handleFieldChange}
                                    required
                                />
                            </td>
                        </tr>
                        <tr>
                            <td className="font-bold label">Tag Group</td>
                            <td>
                                <select
                                    name="tag_group_id"
                                    value={newTag.tag_group_id}
                                    onChange={handleFieldChange}
                                >
                                    {tagGroupOptions.map((tagg) => (
                                        <option
                                            key={tagg.value}
                                            value={tagg.value}
                                        >
                                            {tagg.label}
                                        </option>
                                    ))}
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className="font-bold label">Visibility</td>
                            <td>
                                <select
                                    name="visibility"
                                    value={newTag.visibility}
                                    onChange={handleFieldChange}
                                >
                                    {VISIBILITY_OPTIONS.map((option) => (
                                        <option
                                            key={`visibility-${option.value}`}
                                            value={option.value}
                                        >
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className="font-bold label">Region</td>
                            <td>
                                <select
                                    name="region_ident"
                                    value={newTag.region_ident}
                                    onChange={handleFieldChange}
                                >
                                    {regionsToShow.map((reg) => (
                                        <option
                                        key={`tag-group-${reg}`}
                                            value={reg}
                                        >
                                            {reg}
                                        </option>
                                    ))}
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <button type="submit" className="mt-4 button save-changes-button">
                                    Add Tag
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </form>
        </section>
    );
});

export default CSNewTag;
